import { apiGet, apiPost, apiPut, apiDelete } from '@/app/api/core/http';
import { PROOF_REQUESTS_PATHS } from './paths';

export const proofRequestsApiAdapter = {
  getProofRequests: (params) =>
    apiGet(PROOF_REQUESTS_PATHS.proofRequests + PROOF_REQUESTS_PATHS.suffix, { params, is_protected: true }),
  getProofRequestDetails: (id) => apiGet(`${PROOF_REQUESTS_PATHS.proofRequests}/${id}`),
  postProofRequest: (data) => apiPost(PROOF_REQUESTS_PATHS.proofRequests, { data }),
  deleteProofRequest: (id) => apiDelete(`${PROOF_REQUESTS_PATHS.proofRequests}/${id}`),
  changeProofRequestStatus: (id, status) => apiPut(`${PROOF_REQUESTS_PATHS.proofRequests}/${id}/status/${status}`),
};
